import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Alert,
} from "@mui/material";
import { FormattedMessage, useIntl } from "react-intl";

interface DeleteClassDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  error: string | null;
}

export default function DeleteClassDialog({
  open,
  onClose,
  onConfirm,
  error,
}: DeleteClassDialogProps) {
  const intl = useIntl();
  return (
    <Dialog open={open} onClose={onClose}>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {intl.formatMessage({ id: error })}
        </Alert>
      )}
      <DialogTitle>
        <FormattedMessage id="admin.dashboard.deleteClassConfirmTitle" />
      </DialogTitle>
      <DialogContent>
        <Typography>
          <FormattedMessage id="admin.dashboard.deleteClassConfirmMessage" />
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          <FormattedMessage id="admin.dashboard.cancel" />
        </Button>
        <Button onClick={onConfirm} color="primary" autoFocus>
          <FormattedMessage id="admin.dashboard.confirm" />
        </Button>
      </DialogActions>
    </Dialog>
  );
}
